import React, { useEffect, useState } from "react";
import { listTrashedTimetableWeeks, restoreTimetableWeek, purgeTimetableWeek } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

const fmt = (d) => {
  if (!d) return "?";
  const [y, m, dd] = String(d).split("-");
  return `${dd}/${m}/${y}`;
};
const fmtTime = (ts) => (ts ? new Date(ts).toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit", year: "numeric" }) : "");

// Danh sách tuần TKB đã xoá (soft-delete) — khôi phục lại được, hoặc xoá
// vĩnh viễn nếu chắc chắn không cần nữa.
const HappySchoolTimetableTrash = ({ onRestored }) => {
  const schoolId = getActiveSchoolId();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    listTrashedTimetableWeeks(schoolId)
      .then(setItems)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(reload, [schoolId]); // eslint-disable-line

  const restore = async (w) => {
    setBusyId(w.id); setError(""); setMsg("");
    try {
      await restoreTimetableWeek(schoolId, w.id);
      setMsg(`Đã khôi phục tuần ${fmt(w.startDate)}–${fmt(w.endDate)}.`);
      reload();
      onRestored && onRestored();
    } catch (e) { setError(e.message); }
    finally { setBusyId(""); }
  };

  const purge = async (w) => {
    if (!window.confirm(`Xoá VĨNH VIỄN tuần ${fmt(w.startDate)}–${fmt(w.endDate)}? Không thể khôi phục lại được nữa.`)) return;
    setBusyId(w.id); setError(""); setMsg("");
    try {
      await purgeTimetableWeek(schoolId, w.id);
      setItems((list) => list.filter((x) => x.id !== w.id));
    } catch (e) { setError(e.message); }
    finally { setBusyId(""); }
  };

  if (!schoolId) return null;
  if (loading) return <p>Đang tải...</p>;

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tuần TKB đã xoá — dữ liệu (cấu hình môn học, TKB nghề, lịch bận GV, các bản xếp lịch) vẫn còn, khôi phục lại được.
      </p>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {msg && <p style={{ color: "#059669" }}>{msg}</p>}
      {items.length === 0 ? (
        <p style={{ color: "#9ca3af" }}>Thùng rác trống.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {items.map((w) => (
            <div key={w.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>📅 Tuần {fmt(w.startDate)}–{fmt(w.endDate)}</div>
                <div style={{ fontSize: 12, color: "#9ca3af" }}>Đã xoá lúc {fmtTime(w.deletedAt)}</div>
              </div>
              <button type="button" onClick={() => restore(w)} disabled={busyId === w.id} style={okBtn}>
                {busyId === w.id ? "Đang xử lý..." : "↩️ Khôi phục"}
              </button>
              <button type="button" onClick={() => purge(w)} disabled={busyId === w.id} style={dangerBtn}>
                Xoá vĩnh viễn
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const okBtn = { padding: "7px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const dangerBtn = { padding: "7px 14px", background: "#fff", color: "#dc2626", border: "1px solid #fca5a5", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };

export default HappySchoolTimetableTrash;
